// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"71":"b5533b0e","851":"b8a39a06"}[chunkId] + ".js";
};